import { Modal } from "bootstrap";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../Context/GlobalContext";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { ConvertToBoolean, ConvertToFloat, isValidArray } from "../common";
import { axiosInstance } from "../../../axios/axiosInstance";
import { useAuth } from "../../../Context/AuthContext";

export const PreviousOrderPopup = ({ canShow = true }) => {
  const { CartItem, setCartItem, setOrderId, shownPreviousOrderPopup } = useContext(GlobalContext);
  const { cancelPreviousOrder } = useGlobalFunction();
  const navigate = useNavigate();
  const { userId, isAuthenticated, showPreviousOrderPopup, setUser } = useAuth();
  const modalRef = useRef(null);
  const modalInstanceRef = useRef(null);
  const location = useLocation();
  const [pendingShow, setPendingShow] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  useEffect(() => {
    var isChecked = ConvertToBoolean(localStorage.getItem("checkPreviousOrderPopup"));
    if (!isChecked) checkCartItem();
  }, [userId]);

  useEffect(() => {
    if (!pendingShow || !canShow) return;
    setPendingShow(false);
    modalInstanceRef.current?.show();
  }, [pendingShow, canShow]);

  const checkCartItem = async () => {
    try {
      let response = await axiosInstance.post("MyCart/GetMyCartItem", {
        UserID: String(userId),
        OrderID: "0",
      });
      if (response.data) {
        if (response.data && response.data.orderId) {
          setOrderId(response.data.orderId);
          setCartItem(response.data);
        }
        if (
          response.data &&
          isValidArray(response.data.cartItem) &&
          (!isAuthenticated || showPreviousOrderPopup) &&
          (!shownPreviousOrderPopup || shownPreviousOrderPopup?.current == false)
        ) {
          modalInstanceRef.current = new Modal(modalRef.current, {
            backdrop: "static",
            keyboard: false,
          });
          setTimeout(() => {
            setPendingShow(true);
            // const currentPage = location.pathname.toLocaleLowerCase().trim();
            // if (currentPage.includes("/home")) modalInstanceRef.current.show();
            // else localStorage.setItem("checkPreviousOrderPopup", false);
          }, 750);
        }
      }
      localStorage.setItem("checkPreviousOrderPopup", true);
    } catch (e) {}
  };

  const saveDontShowAgain = () => {
    if (!dontShowAgain || !isAuthenticated) return;
    axiosInstance
      .post("websiteSetting/updatePreviousOrderPopup", {
        UserID: userId,
        showPreviousOrderPopup: false,
      })
      .then((response) => {
        if (response.data == "Success") setUser((prev) => (prev ? { ...prev, showPreviousOrderPopup: false } : prev));
      })
      .catch(() => {});
  };

  const closeModal = () => {
    saveDontShowAgain();
    modalInstanceRef.current?.hide();
  };

  const handleContinue = () => {
    closeModal();
    navigate("/OrderDetails");
  };

  const handleCancel = () => {
    cancelPreviousOrder();
    closeModal();
    setCartItem(null);
    setOrderId(0);
  };

  return (
    <div
      ref={modalRef}
      className="modal fade"
      id="previusOrderdiv"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
      aria-labelledby="staticBackdropLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
        <div className="modal-content">
          <p className="order-status-close" onClick={closeModal}>
            <i className="fa-solid fa-circle-xmark" />
          </p>
          <div className="modal-body p-0">
            {/* Product Not Found */}
            <div className="product-found">
              {/* Header */}
              <div className="product-found-title">
                <img
                  src={"https://cdn.wes.com.au/wesreact/newui/img/cart/shopping-cart.svg"}
                  alt="product-notfound"
                  className="img-fluid"
                />
                <h4>PRODUCTS FOUND IN CART</h4>
              </div>
              {/* Header */}
              {/* Body */}
              <div className="product-found-body">
                <p className="text-center">
                  Your cart still contains items from a previous session. Do you want to proceed with completing that
                  order?
                </p>
                <div className="product-foundButton">
                  <div className="button-effect product-found-btn">
                    <button
                      type="button"
                      onClick={handleContinue}
                      className="btn btn-products btn-addcart btn-proNot-found"
                    >
                      <i className="fa-solid fa-check" /> Continue with Previous Order
                    </button>
                  </div>
                  <div className="border-link">
                    <button
                      type="button"
                      onClick={handleCancel}
                      className="link-proNot-found"
                      style={{ background: "transparent" }}
                    >
                      <i className="fa-solid fa-xmark" /> Cancel Previous Order
                    </button>
                  </div>
                </div>
                {isAuthenticated && (
                  <div className="d-flex align-items-center justify-content-center flex-wrap gap-2 mt-3 small text-muted">
                    <input
                      className="form-check-input m-0"
                      type="checkbox"
                      id="previousOrderDontShowAgain"
                      checked={dontShowAgain}
                      onChange={(e) => setDontShowAgain(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="previousOrderDontShowAgain">
                      Don't show again
                    </label>
                    <span className="d-none">If you want to change, go to My Account &gt; Website Settings</span>
                  </div>
                )}
              </div>
              {/* Body */}
            </div>
            {/* Product Not Found */}
          </div>
        </div>
      </div>
    </div>
  );
};
